import BaseEntity from "./base.entity";
import uuid from "uuid";

export default class User extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid(),
      company: {},
      allowed_companies_uuids: []
    };
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/user.entity.js